import React from 'react';
import { connect } from 'react-redux';
import fecha from 'fecha';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import './styles.css';
import isWebSite from '../../utils/isWebSite';
import {
  getAvailableStudents,
  getRemainingHours,
  getTutorSubjects,
  submitTimesheet
} from '../../actions/actions';
import {
  renderInput,
  renderSelect
} from '../../components/InputField/RenderField';
import { warningIcon } from '../../images/warningIcon.png';

const timeOptions = [
  {
    value: '',
    label: 'Please select'
  }
];
for (let i = 300; i <= 1320; i += 30) {
  let hours = Math.floor(i / 60);
  let minutes = i - hours * 60;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  timeOptions.push({
    value: i,
    label: `${hours}:${minutes}`
  });
}

const required = value => (!value || value === '' ? 'Required' : undefined);
const requiredNumber = value =>
  isNaN(parseFloat(value)) || !isFinite(value) ? 'Required' : undefined;

const formatDate = value => {
  const dateObj = new Date(value);

  return fecha.format(dateObj, 'ddd, MMMM DD YYYY');
};

const getDuration = values => {
  const duration = Number(values.endTime) - Number(values.startTime);
  let durationString = '';

  const minutes = duration % 60;
  const hours = (duration - minutes) / 60;
  if (hours > 0 && minutes > 0) {
    durationString = `${hours}h ${minutes}m`;
  } else if (minutes > 0) {
    durationString = `${minutes}m`;
  } else if (hours > 0) {
    durationString = `${hours}h`;
  }

  return durationString;
};

class NewTimesheet extends React.Component {
  constructor() {
    super();
    this.state = {
      formValues: null,
      saving: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleConfirmClick = this.handleConfirmClick.bind(this);
    this.handleStudentChange = this.handleStudentChange.bind(this);
    this.handleSubjectCategoryChange = this.handleSubjectCategoryChange.bind(
      this
    );
  }

  componentDidMount() {
    this.props.dispatch(getAvailableStudents());
    this.props.dispatch(getTutorSubjects());
  }

  handleSubmit(values) {
    const date = values.date.replace(/-/g, '/');
    this.setState({
      formValues: { ...values, date }
    });
  }

  handleSubjectCategoryChange() {
    this.props.change('subjectId', '');
  }

  handleStudentChange(e, value) {
    this.props.dispatch(getRemainingHours({ studentId: value }));
  }

  handleEditClick(e) {
    e.preventDefault();
    this.setState({
      formValues: null
    });
  }

  handleConfirmClick(e) {
    e.preventDefault();
    if (this.saving) {
      return;
    }
    this.saving = true;
    const values = this.state.formValues;
    const startTime = timeOptions.find(
      obj => obj.value === Number(values.startTime)
    ).label;
    const endTime = timeOptions.find(
      obj => obj.value === Number(values.endTime)
    ).label;

    const dateObj = new Date(values.date);
    const date = fecha.format(dateObj, 'YYYY-MM-DD');

    const params = {
      ...values,
      date,
      startTime,
      endTime,
      duration: getDuration(values)
    };

    this.setState({
      saving: true
    });
    this.props.dispatch(submitTimesheet(params)).then(() => {
      this.setState({
        saving: false
      });

      if (isWebSite()) {
        window.history.back();
      } else {
        window.location = 'https://action/go_back';
      }
    });
  }

  renderConfirmation() {
    const values = this.state.formValues;

    const { availableStudents, tutorSubjects } = this.props;
    const student = availableStudents.find(
      obj => Number(obj.id) === Number(values.studentName)
    );
    const studentName = `${student.firstName} ${student.lastName}`;

    const startTime = timeOptions.find(
      obj => obj.value === Number(values.startTime)
    ).label;
    const endTime = timeOptions.find(
      obj => obj.value === Number(values.endTime)
    ).label;

    const durationString = getDuration(values);

    const date = formatDate(values.date);

    const subjectName = tutorSubjects[values.subjectCategory].find(
      subject => Number(subject.id) === Number(values.subjectId)
    ).name;

    return (
      <div className="timesheet__confirmation">
        <div>
          <h2>Please confirm the details below:</h2>
          <table>
            <tbody>
              <tr>
                <td>Client's Name:</td>
                <td>{studentName}</td>
              </tr>
              <tr>
                <td>Subject:</td>
                <td>{subjectName}</td>
              </tr>
              <tr>
                <td>Date:</td>
                <td>{date}</td>
              </tr>
              <tr>
                <td>Time:</td>
                <td>
                  {startTime} to {endTime} ({durationString})
                </td>
              </tr>
              <tr>
                <td>Hourly Rate:</td>
                <td>${values.rate}</td>
              </tr>
            </tbody>
          </table>
          <h2>What will happen next?</h2>
          <p>
            We will send a text to the parent/student and they will need to
            confirm the hours. If you are near them, you can encourage them to
            respond quickly. Once confirmed, timesheet will be added to the
            current pay period.
          </p>
          <div className="timesheet__warning">
            <div>
              <img src={warningIcon} alt="" />
            </div>
            <div>Once timesheet is submitted it cannot be edited.</div>
          </div>
          <div className="timesheet__button-row">
            <button
              className="button button--inline button--secondary"
              onTouchStart={this.handleEditClick}
              onMouseDown={this.handleEditClick}
              disabled={this.state.saving}
            >
              Edit
            </button>
          </div>
          <div className="timesheet__button-row">
            <button
              className="button button--inline"
              onTouchStart={this.handleConfirmClick}
              onMouseDown={this.handleConfirmClick}
              disabled={this.state.saving}
            >
              {this.state.saving ? 'Saving' : 'Confirm'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  /*
  <div className="loader">
            <section>
              <div />
            </section>
          </div>
   */

  render() {
    const {
      handleSubmit,
      valid,
      availableStudents,
      tutorSubjects,
      subjectCategory
    } = this.props;

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        {this.state.formValues && this.renderConfirmation()}
        <div className="timesheet__row">
          <label>Client's Name</label>
          <div className="timesheet__select timesheet--arrow">
            <Field
              name="studentName"
              component={renderSelect}
              validate={required}
              disabled={!availableStudents}
              onChange={this.handleStudentChange}
            >
              <option value="">
                {!availableStudents ? 'Loading options...' : 'Please Select'}
              </option>
              {availableStudents &&
                availableStudents.map(option => (
                  <option key={option.id} value={option.id}>
                    {`${option.firstName} ${option.lastName}`}
                  </option>
                ))}
            </Field>
          </div>
        </div>
        <div className="timesheet__row">
          <label>Subject</label>
          <div className="timesheet__select timesheet--arrow">
            <Field
              name="subjectCategory"
              component={renderSelect}
              validate={required}
              disabled={!tutorSubjects}
              onChange={this.handleSubjectCategoryChange}
            >
              <option value="">
                {!tutorSubjects ? 'Loading options...' : 'Please Select'}
              </option>
              {tutorSubjects &&
                Object.keys(tutorSubjects).map(category => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
            </Field>
          </div>
        </div>
        <div className="timesheet__row">
          <label>Subject Category</label>
          <div className="timesheet__select timesheet--arrow">
            <Field
              name="subjectId"
              component={renderSelect}
              validate={required}
              disabled={!tutorSubjects || !subjectCategory}
            >
              <option value="">
                {!tutorSubjects
                  ? 'Loading options...'
                  : `Please Select${subjectCategory ? '' : ' Category'}`}
              </option>
              {tutorSubjects &&
                subjectCategory &&
                tutorSubjects[subjectCategory].map(subject => (
                  <option key={subject.id} value={subject.id}>
                    {subject.name}
                  </option>
                ))}
            </Field>
          </div>
        </div>
        <div className="timesheet__row timesheet__row--two">
          <div>
            <label>Date of the session </label>
            <Field
              type="date"
              name="date"
              component={renderInput}
              validate={required}
              className="timesheet--arrow"
            />
          </div>
          <div />
        </div>
        <div className="timesheet__row timesheet__row--two">
          <div>
            <label>Start Time </label>
            <div className="timesheet__select timesheet--arrow">
              <Field
                name="startTime"
                component={renderSelect}
                validate={required}
              >
                {timeOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Field>
            </div>
          </div>
          <div>
            <label>End Time </label>
            <div className="timesheet__select timesheet--arrow">
              <Field
                name="endTime"
                component={renderSelect}
                validate={required}
              >
                {timeOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Field>
            </div>
          </div>
        </div>
        <div className="timesheet__row timesheet__row--two">
          <div>
            <label>Hourly Rate</label>
            <Field
              type="number"
              name="rate"
              component={renderInput}
              validate={requiredNumber}
            />
          </div>
          <div />
        </div>
        <div className="timesheet__row">
          <button
            className="button button--inline"
            type="submit"
            disabled={!valid}
          >
            Submit
          </button>
        </div>
      </form>
    );
  }
}

const form = reduxForm({
  form: 'timesheet',
  validate: values => {
    const timeError =
      Number(values.startTime) >= Number(values.endTime)
        ? 'Invalid time range'
        : undefined;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selected = new Date(values.date);
    selected.setHours(0, 0, 0, 0);
    return {
      startTime: timeError,
      endTime: timeError,
      date: selected.getTime() > today.getTime() ? 'Invalid date' : undefined
    };
  }
})(NewTimesheet);

const selector = formValueSelector('timesheet');

export default connect(state => ({
  availableStudents: state.availableStudents,
  tutorSubjects: state.tutorSubjects,
  subjectCategory: selector(state, 'subjectCategory')
}))(form);
